import React, { useEffect } from "react";
import { Modal, Input, Form } from "antd";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { getError } from "../../utils/form";
const schema = yup.object().shape({
  trackingId: yup.string().required("Field can't be empty"),
});

const ControlledInput = ({ control, errors, name, required }) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          required={required}
          validateStatus={error ? "error" : ""}
          help={error?.message}
        >
          <div
            style={{
              fontWeight: 600,
              color: "#333",
              fontSize: 15,
              marginBottom: 10,
              marginTop: 10,
            }}
          >
            Enter Tracking ID:
          </div>
          <Input {...field} placeholder="Enter Tracking ID" size="large" />
        </Form.Item>
      )}
    />
  );
};

const AddTrackingDetailsForm = ({
  visible,
  setVisible,
  onSave,
  isLoading,
  setOrderDetails,
  orderDetails,
}) => {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      trackingId: "",
    },
    resolver: yupResolver(schema),
  });

  const onSubmit = (data) => {
    onSave(data);
  };

  const handleCancel = () => {
    reset();
    setVisible(false);
    setOrderDetails(null);
  };

  useEffect(() => {
    setValue("trackingId", orderDetails?.trackingId || "");
  }, [orderDetails]);

  return (
    <Modal
      title={
        orderDetails?.trackingId
          ? "Edit Tracking Details"
          : "Add Tracking Details"
      }
      visible={visible}
      okText="Save"
      onOk={handleSubmit(onSubmit)}
      onCancel={handleCancel}
      confirmLoading={isLoading}
    >
      <ControlledInput
        required={true}
        control={control}
        name="trackingId"
        errors={errors}
      />
    </Modal>
  );
};

export default AddTrackingDetailsForm;
